/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Outsideairhumidity2Inputs */



/**
* | output |
* | --- |
* | "Fresh air humidity" |
*
* @param {Ahu_History_Key_Outsideairhumidity2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_outsideairhumidity2 = /** @type {((inputs?: Ahu_History_Key_Outsideairhumidity2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Outsideairhumidity2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Fresh air humidity")
	return /** @type {LocalizedString} */ ("Humidité air neuf")
});
export { ahu_history_key_outsideairhumidity2 as "ahu_history_key_outsideAirHumidity" }